module.exports = __webpack_public_path__ + "Panton-Bold.fc3088d34c25.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Panton-Bold.woff
// module id = ./src/styles/fonts/Panton-Bold.woff
// module chunks = 21